<template>
  <div>
    <div class="p-relative header-image pb-5">
      <div
        class="w-100 text-center white--text font-weight-bold header-text py-4"
      >
        Welcome
        <div v-if="user" class="d-inline-block">, {{ user.full_name }}</div>
        . Quickly search for any cards or passes.
      </div>

      <search-bar @searchedFile="fileSearch" />
    </div>

    <b-container v-show="searchedFile" class="custom-container mt-5">
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="p-relative my-2 mb-5 my-md-0 mb-md-0 d-flex align-items-end"
              >
                <h4 class="font-weight-bold">All Search Results</h4>
              </b-col>
              <b-col
                sm="12"
                md="6"
                lg="6"
                class="p-relative d-flex justify-content-center justify-content-md-end align-items-end"
              >
                <!-- <b-button
                  @click="bulkDownload()"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                >
                  <b-icon icon="download"></b-icon> Download
                </b-button> -->
                <b-button-group
                  v-show="checkedFiles.length"
                  variant="outlined"
                  class="float-sm-right font-weight-bold gray--2"
                  :disabled="loading"
                >
                  <b-dropdown
                    :text="`Selected ${checkedFiles.length} item/s`"
                    variant="outlined"
                    class="gray--2"
                  >
                    <b-dropdown-item @click="bulkDownload">
                      <b-icon
                        icon="download"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Download Selected Item/s
                    </b-dropdown-item>
                    <!-- <b-dropdown-item @click="shareFiles">
                      <b-icon
                        icon="cursor"
                        class="mr-2"
                        aria-hidden="true"
                      ></b-icon>
                      Share Selected File/s
                    </b-dropdown-item> -->
                  </b-dropdown>
                  <b-button
                    right
                    variant="outlined"
                    class="gray--2"
                    @click="clearSelectedFiles"
                  >
                    Clear
                  </b-button>
                </b-button-group>
              </b-col>
            </b-row>
          </b-container>
          <b-card border-variant="light" bg-variant="light" body-class="px-0">
            <file-list
              :files="files"
              ref="searchedFileList"
              @selectedFiles="filesSelected"
              @shareSingleFile="shareFiles"
            />

            <p v-if="searchedFile && !files.length" class="mb-0 px-3">
              No File/s found.
            </p>
          </b-card>
        </b-col>
      </b-row>
    </b-container>

    <!-- <div fluid-grow alt="banner" class="header-image rounded-0"></div> -->

    <b-container
      v-show="!searchedFile"
      v-if="homeData.data"
      class="custom-container mt-5"
    >
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.recent-requested
                  variant="link"
                  class="px-0 text-dark text-decoration-none"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    {{
                      !isEmptyObj(user) && user.user_type === 'business_admin'
                        ? 'Recently Requests You Created'
                        : 'Recently Requests Assigned To You'
                    }}
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'requests.list-page'
                    })
                  "
                  class="py-4 pl-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all requests
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="recent-requested" class="mt-2">
            <b-card
              border-variant="light"
              bg-variant="light"
              body-class="px-0 py-0"
            >
              <home-page-request-file-list
                v-if="homeData.data && homeData.data.recent_requests"
                :files="homeData.data.recent_requests"
              />
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.file-shared
                  variant="link"
                  class="px-0 text-dark text-decoration-none"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    {{
                      !isEmptyObj(user) && user.user_type === 'business_admin'
                        ? 'Files Shared With You'
                        : 'Recently Uploaded Files'
                    }}
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'file.list-page',
                      params: { tab: 'shared' }
                    })
                  "
                  class="py-4 pl-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all files
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="file-shared">
            <b-card border-variant="light" bg-variant="light" body-class="px-0">
              <div
                v-if="!isEmptyObj(user) && user.user_type === 'business_admin'"
              >
                <file-list
                  v-if="
                    homeData.data.recent_shares ||
                      !isEmptyObj(homeData.data.recent_shares)
                  "
                  :files="homeData.data.recent_shares"
                />
                <div v-else class="text-center">
                  <!-- v-if="!homeData.data.recent_shares.length" -->
                  Empty file/s data
                </div>
              </div>
              <div v-else>
                <file-list
                  v-if="
                    homeData.data.recent_files ||
                      !isEmptyObj(homeData.data.recent_files)
                  "
                  :files="homeData.data.recent_files"
                />
                <div v-else class="text-center">
                  <!-- v-if="!homeData.data.recent_files.length" -->
                  Empty file/s data
                </div>
                <!-- <file-list v-else :files="homeData.data.recent_files" /> -->
              </div>
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12" class="px-3">
          <b-container fluid>
            <b-row>
              <b-col cols="12" sm="6">
                <b-button
                  v-b-toggle.expiring-soon
                  variant="link"
                  class="px-0 text-dark text-decoration-none"
                >
                  <h4 class="font-weight-bold pt-4 mb-4 align-middle">
                    Expiring Soon
                    <span class="when-open">
                      <b-icon icon="caret-up-fill" scale="0.5"></b-icon>
                    </span>
                    <span class="when-closed">
                      <b-icon icon="caret-down-fill" scale="0.5"></b-icon>
                    </span>
                  </h4>
                </b-button>
              </b-col>
              <b-col cols="12" sm="6">
                <a
                  type="button"
                  @click="
                    $router.push({
                      name: 'file.list-page'
                    })
                  "
                  class="py-4 pl-2 ml-sm-auto float-sm-right text-decoration-underline text-primary"
                >
                  See all files
                </a>
              </b-col>
            </b-row>
          </b-container>
          <b-collapse :visible="true" id="expiring-soon">
            <b-card border-variant="light" bg-variant="light" body-class="px-0">
              <div
                v-if="!homeData.data.expiring_soon.length"
                class="text-center"
              >
                Empty file/s data
              </div>
              <file-list v-else :files="homeData.data.expiring_soon" />
            </b-card>
          </b-collapse>
        </b-col>
      </b-row>
    </b-container>

    <share-file-modal
      :showShareFiles="showShareFiles"
      :selectedFiles="checkedFiles"
      :fileShares="fileShares"
      @closeShareFileModal="showShareFiles = false"
      @fileShareResponsePrompt="shareFileResponsePrompt"
      @reloadFileList="getFileList"
    />

    <b-alert
      class="custom-alert"
      :show="dismissCountDown"
      :class="{
        'bg-danger border-danger': alertType === 'danger'
      }"
      dismissible
      fade
      :variant="alertType"
      @dismiss-count-down="countDownChanged"
    >
      {{ alertMsg }}
    </b-alert>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isEmpty } from 'lodash'
import SearchBar from '@/components/SearchBar'
import FileList from '@/components/lists/FileList'
import HomePageRequestFileList from '@/components/lists/HomePageRequestFileList'
import ShareFileModal from '@/components/modals/ShareFileModal'

export default {
  components: {
    SearchBar,
    FileList,
    HomePageRequestFileList,
    ShareFileModal
  },

  data() {
    return {
      loading: false,
      checkedFiles: [],
      searchedFile: '',
      showShareFiles: false,
      fileShares: [],
      dismissCountDown: 0,
      alertMsg: null,
      alertType: 'primary'
    }
  },

  computed: {
    // ...mapState({
    //   user: state => state.auth.user
    // }),
    ...mapGetters('auth', ['user']),
    ...mapGetters('file', ['files']),
    ...mapGetters('home', ['homeData'])
  },
  methods: {
    ...mapActions({
      getFiles: 'file/getFiles',
      getHomeData: 'home/getHomeData',
      getSearchedFiles: 'file/getSearchedFiles'
    }),
    async getFileList() {
      this.loading = true
      await this.getFiles()
      this.loading = false
    },
    async getHomePageData() {
      this.loading = true

      await this.getHomeData().finally(() => {
        this.loading = false
      })
    },
    filesSelected(files) {
      this.checkedFiles = files
    },
    clearSelectedFiles() {
      this.checkedFiles = []

      this.$refs.searchedFileList.clearFilesSelected()
    },
    async bulkDownload() {
      await this.$api
        .get('download-bulk-files', {
          responseType: 'blob',
          params: { files: this.checkedFiles }
        })
        .then(data => {
          const name = this.user.full_name
          const filename = `${name}.zip`
          const url = URL.createObjectURL(
            new Blob([data.data], {
              type: 'application/zip'
            })
          )
          const link = document.createElement('a')

          link.href = url
          link.setAttribute('download', filename)
          document.body.appendChild(link)
          link.click()
        })
        .catch(e => {
          setTimeout(e => {
            this.$emit('showAlert', 'downloaded unsuccessfully.')
          }, 5000)
        })
    },
    async fileSearch(name) {
      this.searchedFile = name
      this.clearSelectedFiles()

      if (!this.searchedFile) {
        await this.getFileList()
      } else {
        await this.getSearchedFiles(this.searchedFile)
          .then(res => {})
          .catch(error => {
            this.$emit('showAlert', 'error while searching for file/s: ', error)
          })
      }
    },
    shareFiles() {
      let fileShared = find(this.files, { id: this.checkedFiles[0] })
      this.fileShares = fileShared.file_shares
      this.showShareFiles = true
    },
    async shareFileResponsePrompt(res) {
      if (res.success) {
        await this.getFileList()

        this.alertMsg =
          'File shared successfully to selected Business Admin emails: ' +
          res.data.success.join(', ')

        this.dismissCountDown = 15

        return
      } else {
        this.alertType = 'danger'

        if (res.status === 402 || res.status === 422) {
          if (res.message) {
            this.alertMsg = res.message
          } else {
            this.alertMsg = 'File shared unsuccessful!'
          }
        } else {
          this.alertMsg =
            'Something went wrong while submitting the share file email!'
        }
      }

      this.dismissCountDown = 5
    },
    showAlert() {
      this.dismissCountDown = 5
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    clearAlert() {
      this.dismissCountDown = 0
      this.alertMsg = null
      this.alertType = 'primary'
    },
    isEmptyObj(obj) {
      return isEmpty(obj)
    }
  },
  watch: {
    async user() {
      await this.getHomePageData()
    }
  }
  // mounted() {
  //   this.getFileList()
  // }
}
</script>

<style lang="scss" scoped>
.header-image {
  // top: 88px;
  // height: 280px;
  background: transparent linear-gradient(130deg, #006cff 0%, #00429d 100%) 0%
    0% no-repeat padding-box;
}

.header-text {
  // top: 136px;
  margin-top: 88px;
  font-size: 35px;
}

/deep/ nav.center-screen {
  margin-top: 0;
}

/deep/ .collapsed {
  .when-open {
    display: none;
  }
}

/deep/ .not-collapsed {
  .when-closed {
    display: none;
  }
}
</style>
